import { useTranslation } from "react-i18next";
import CustomModal from "../components/modal";

export default function BaseConfirmationModal({ showModal, message, onResolveConfirmation, title }) {

    const { t } = useTranslation();

    return (
        <CustomModal open={showModal} setOpen={() => onResolveConfirmation(false)} title={title} confirmButton={t('buttons.confirm')} cancelButton={t('buttons.cancel')} onConfirm={() => onResolveConfirmation(true)} onCancel={() => onResolveConfirmation(false)}>
            <span>
                {message} 
            </span>
        </CustomModal>
    )

}
